import { useFont } from '@octane/spark'
import styled from 'styled-components'

export const VinSectionContainer = styled.div`
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    gap: 20px;
`

export const BorderLine = styled.div`
    width: 100%;
    height: 0px;
    border-top: 1px solid #d5d9e0;

    flex: none;
    order: 0;
    flex-grow: 0;
    margin-bottom: 1em;
`

export const TooltipListContainer = styled.ul`
    margin: 0;
    padding-left: 1.2em;
`

export const CpoCheckboxContainer = styled.div`
    display: flex;
    align-items: center;
    margin-top: 16px;
`

export const CpoCheckboxLabel = styled.label`
    margin-left: 10px;
`

export const AccessoriesSection = styled.div`
    margin-top: 16px;
`

export const AccessoriesTitle = styled.p`
    font-weight: 600;
    margin-bottom: 8px;
`

export const AccessoryCategoryTitle = styled.h4`
    ${() => useFont('c14', { weight: '700' })}
    color: ${({ theme }) => theme.colors.brand.primary};
    text-transform: uppercase;
    margin-bottom: 8px;
`

export const AccessoryItem = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 8px;

    span {
        ${() => useFont('c16', { weight: '400' })}
    }
`
